<template>
  <div id="upLoadImg">
    <upload
      ref="testUp"
      :action="uploadUrl"
      :on-preview="handlePictureCardPreview"
      :on-success="onUpLoadFile"
      :on-error="onUpLoadError"
      :before-upload="beforeFileUpload"
      :limit="limit"
      :accept="typeArr.join(',')"
      :file-list="fileList"
      :on-remove="handleRemove"
      :disabled="fileList.length < limit ? false : true"
    >
      <el-button
        :disabled="fileList.length < limit ? false : true"
        size="small"
        type="primary"
      >点击上传</el-button
      >
      <div
        slot="tip"
        class="el-upload__tip"
        v-if="tip"
        style="
          display: inline-block;
          color: red;
          margin-left: 5px;
          vertical-align: middle;
        "
      >
        {{ tip }}
      </div>
    </upload>
  </div>
</template>

<script>
  import util from "../../libs/util";
  import upload from "@/components/upload";

  // const fileTypes = ["doc", "docx", "xls", "xlsx", "ppt", "pptx", "pdf"];

  export default {
    components: { upload },
    filters: {},
    props: {
      tip: {
        default: "",
      },
      typeArr: {
        default() {
          return [];
        },
      },
      value: [String, Number],
      limit: {
        default: 5,
      },
      minSize: {
        default: 0,
      },
      dtsc: {
        default: false,
      },
    },
    data() {
      return {
        uploadUrl: util.baseUrl + "api/common/upload",
        fileList: [],
        fileStr: this.value,
        dialogImageUrl: "",
        dialogVisible: false,
        dtscc: "", // 文件上传格式限制,默认无
        fileList_:[],
        uploadNum:0 //计数正在上传的文件
      };
    },
    methods: {
      beforeFileUpload(file) {
        if(this.pdFile(file)){
          this.$message.error('请勿重复上传')
          return false;
        }
        console.log(file)
        if(file.name.indexOf(',')!==-1){
          this.$message.error('文件名请勿含有","";"等特殊符号')
          return false;
        }
        if(this.typeArr && this.typeArr.length){
          if (!this.typeArr.includes(file.type)) {
            this.$message.error(`上传的文件格式不对!`);
            return false;
          }
        }
        if (this.minSize > 0) {
          let isBigger = file.size / 1024 / 1024 >= this.minSize;
          if (!isBigger) {
            this.$message.error(`上传文件大小不能小于${this.minSize}MB!`);
            return false;
          }
        } else {
          // this.fileList_.push({
          //   name:file.name,
          //   file:file,
          // })
        }
        this.uploadNum++
      },
      onUpLoadFile(response, file, fileList) {
        console.log(response,fileList,file)
        this.uploadNum--
        this.fileList = fileList;
        let arr = [];
        this.fileList.map((item) => {
          arr.push(item.response.result.path + "," + item.name + "," + item.response.result.realPath);
        });
        this.fileStr = arr.join(";");
      },
      onUpLoadError() {
        this.uploadNum--
        this.$message.error("上传失败!");
      },
      handleRemove(file, fileList) {
        console.log(file,fileList)
        this.fileList = fileList;
        let arr = [];
        this.fileList.map((item) => {
          arr.push(item.response.result.path + "," + item.name + "," + item.response.result.realPath);
        });
        this.fileStr = arr.join(";");
        if(file.status==='uploading'){
          this.uploadNum--
        }
        // this.fileList_ = this.fileList_.filter(item=>{ return item.name!==file.name })
        // console.log(this.fileList_)
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      pdFile(file){
        if(this.fileList.length){
          let flag = false
          this.fileList.map((item,index)=>{
            if(item.name ===file.name){
              flag = true
            }
          })
          return flag
        }
      }
    },
    mounted() {
      if (this.dtsc) {
        this.dtscc = this.dtsc;
      }
    },
    watch: {
      fileStr(val) {
        let file = val;
        if (val) {
          file = val.split(";");
          let objArr = [];
          file.map((item) => {
            let fileItem = item.split(",");
            objArr.push({
              url: fileItem[0],
              name: fileItem[1],
              response: { result: { path: fileItem[0],realPath:fileItem.length>2?fileItem[2]:'' } },
            });
          });
          this.fileList = objArr;
        } else {
          this.fileList = [];
        }
        this.$emit("input", val);
      },
      value(val) {
        console.log(val)
        this.fileStr = val;
      },
    },
  };
</script>

<style scoped>
</style>
